import { SilverwareSpoonIcon } from './SilverwareSpoonIcon';

/**
 * author: Austin Andrews
 * id 5FCBB812-F381-4E83-B60E-E126992910FB
 * name silverware-spoon
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silverware-spoon.svg
 * tags
 * - Food / Drink 
 */
export const UtensilsSpoonIcon = SilverwareSpoonIcon;
export default UtensilsSpoonIcon